import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <section className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <Card className="border-2 border-gray-300">
              <CardContent className="pt-12 pb-12 text-center">
                <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <XCircle className="w-12 h-12 text-gray-600" />
                </div>
                <h1 className="text-3xl font-bold text-gray-900 mb-4">Payment Cancelled</h1>
                <p className="text-xl text-gray-700 mb-8">
                  Your payment was cancelled. No charges were made.
                </p>

                <div className="bg-gray-50 p-6 rounded-lg mb-8">
                  <p className="text-gray-700 mb-4">
                    If you experienced any issues or have questions, please don't hesitate to contact us.
                  </p>
                  <p className="text-gray-700">
                    We're here to help make your move smooth and stress-free!
                  </p>
                </div>

                <div className="flex gap-4 justify-center">
                  <Button 
                    onClick={() => navigate('/pay-deposit')} 
                    className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-semibold"
                  >
                    Try Again
                  </Button>
                  <a href="tel:1800233023">
                    <Button variant="outline" className="border-2 border-gray-900">
                      Call Us: 1800 233 023
                    </Button>
                  </a>
                  <Button onClick={() => navigate('/')} variant="outline">
                    Back to Home
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
